export default "__VITE_ASSET__CbqomwjY__"